const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkerBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "parker",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.14 273.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "ab3f7d63-62c3-4ae4-929e-ee60d04603c4",
    "data-name": "border",
    d: "M153.93,154.62c-8.73,1.08-18.38-4.86-22.87-2.37s-12.75,15.64-12.33,21.15-2.26,30.25,1.37,30.27,9.39-1.34,11.44.49-5.37,22-5,27.24,4.41,28.3,4.11,28.5c-4.6,3.16-21.37,14.52-24.07,12.69s-3.46-10.42-8.09-12.35-35.3-3.26-39-3.28S28,268.56,25.29,263.8s1.58-16.37-2.93-19.12-19.83-5.77-21.13-16c-.78-6.13-2.54-25.59,5.39-29,6.07-2.64,27.55-4.17,36.29-3.28s15.76,1.85,15.7-3.22,2-5.25-.93-11c-7.64-15.06-15.63-8.19-22-11.4s-15.1-8.54-17.93-24,4.22-25.81,2-36.72-6.4-26.25-1.11-32.46c8.94-10.5,5.82-24.75,7.07-35S34.79,28,39,19.78,50.06,1,59.73.56,83,2.47,92,5.84c6.5,2.42,17.54,3.45,25.8,4.85s25.05,10.78,26.56,22.11c1.1,8.19,6.17,19.7,7.3,27.78s-.51,16.62.61,16.64,16,5.13,15.3,10.72,7,2.07,9.79,14.76.72,38.27-3,44.39S153.93,154.62,153.93,154.62Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkerBorder);
export default __webpack_public_path__ + "static/media/parker-border.9a7697c72f26385bda21ca628166e279.svg";
export { ForwardRef as ReactComponent };